<script setup lang="ts">
import { faChevronRight } from '@fortawesome/pro-light-svg-icons'

import { type Category } from '@consumer/logic/v2/header'
import BuyAGift from '@consumer/modules/v2/layout/Header/BuyAGift.vue'

const category = defineModel<Category | null>('category')
const open = defineModel<boolean>('open')
</script>

<template>
  <GMobileModal v-model:open="open">
    <template #header>
      <div
        v-if="category"
        class="w-full text-base font-semibold flex items-center justify-center gap-2"
      >
        <GIcon :icon="category.icon" size="md"/>
        {{ category.title }}
      </div>
    </template>

    <div v-if="category" class="flex flex-col gap-6">
      <div v-if="category?.buyAGift">
        <BuyAGift
          :label="category.buyAGift.label"
          :path="category.buyAGift.path"
          :image="category.buyAGift.image"
          class="!w-full"
        />
      </div>
      <V2List class="border-0 shadow-transparent !p-0">
        <V2ListItem
          v-for="subCategory in category.links"
          :key="subCategory.name"
          as="a"
          :href="subCategory.path"
          class="w-full"
          :label="subCategory.name"
          :icon="subCategory.icon"
          :image="subCategory.image"
        >
          <template #addonRight>
            <div>
              <GIcon
                :icon="faChevronRight"
                size="sm"
                class="text-v2-tertiary"
              />
            </div>
          </template>
        </V2ListItem>
      </V2List>
    </div>
  </GMobileModal>
</template>
